import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatProgressSpinner, MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { WindowDetectService } from '@service/window-detect.service';

@Component({
  selector: 'app-progress',
  templateUrl: './progress.component.html',
  styleUrls: ['./progress.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatProgressSpinner, MatProgressSpinnerModule],
})
export class ProgressComponent {
  static progressId = 'progressDialog';

  readonly detectService = inject(WindowDetectService);
  readonly diameter = computed(() => (this.detectService.isMobileDevice() ? 20 : 40));

  static open(dialog: MatDialog): MatDialogRef<unknown> {
    return dialog.open(ProgressComponent, {
      panelClass: 'progress-dialog-container',
      id: ProgressComponent.progressId,
      disableClose: true,
    });
  }
}
